import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

const locationLegendBlockStyles = {
    locationLegendBlock: css({
        position: 'fixed',
        padding: '0 15px',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        gap: 13,
        bottom: '24%',
        display: 'flex',
        backgroundColor: 'transparent',
        zIndex: Z_INDEX.LOCATION_LEGEND,

        '@media (min-width: 600px)': {
            bottom: 30,
            padding: '0 30px',
        },
    }),
    buttonsBlock: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
    }),
};

export default locationLegendBlockStyles;
